<template>
  <div>
    <ssp-sign-in
      v-if="authStatus.showSignIn"
      v-bind:signInConfig="options.signInConfig"
    ></ssp-sign-in>
    <ssp-confirm-sign-up
      v-if="authStatus.showConfirmSignUp"
      v-bind:confirmSignUpConfig="options.confirmSignUpConfig"
    ></ssp-confirm-sign-up>

    <ssp-require-new-password
      v-if="authStatus.requireNewPassword"
      v-bind:requireNewPasswordConfig="options.requireNewPasswordConfig"
    ></ssp-require-new-password>

    <ssp-forgot-password
      v-if="authStatus.showForgotPassword"
      v-bind:forgotPasswordConfig="options.forgotPasswordConfig"
      v-bind:requirePasswordReset="authStatus.requirePasswordReset"
    ></ssp-forgot-password>
  </div>
</template>

<script>
import AuthEventBus from '../events/authEventBus'
import router from '@/config/router/router'
import { getUser } from '../services'
import { SHOWCASE_AUTOMATION_PATH } from '@/domain/showcases/routes/routes'
export default {
  name: 'Authenticator',
  props: ['authConfig'],
  data() {
    return {
      user: {
        username: null
      },
      authStatus: {},
      error: '',
      logger: {}
    }
  },
  computed: {
    options() {
      const defaults = {
        signInConfig: {},
        confirmSignUpConfig: {},
        requireNewPasswordConfig: {},
        forgotPasswordConfig: {}
      }
      return Object.assign(defaults, this.authConfig || {})
    }
  },
  async mounted() {
    AuthEventBus.$on('localUser', user => {
      this.user = user
      this.options.signInConfig.username = this.user.username
      this.options.confirmSignUpConfig.username = this.user.username
      this.options.requireNewPasswordConfig.user = this.user
    })
    AuthEventBus.$on('authState', data => {
      this.authStatus = this.updateDisplayMap(data)
      this.forwardIfSignedIn(data)
    })
    getUser()
      .then(val => {
        if (val instanceof Error) {
          return (this.authStatus = this.updateDisplayMap('signedOut'))
        }
        this.user = val
        return (this.authStatus = this.updateDisplayMap('signedIn'))
      })
      .catch(e => this.setError(e))
  },
  methods: {
    updateDisplayMap: state => {
      return {
        showSignIn: state === 'signedOut' || state === 'signIn',
        showSignUp: state === 'signUp',
        showConfirmSignUp: state === 'confirmSignUp',
        showConfirmSignIn: state === 'confirmSignIn',
        showForgotPassword:
          state === 'forgotPassword' || state === 'requirePasswordReset',
        requirePasswordReset: state === 'requirePasswordReset',
        showSignOut: state === 'signedIn',
        showMfa: state === 'setMfa',
        requireNewPassword: state === 'requireNewPassword'
      }
    },
    forwardIfSignedIn: state => {
      if (state === 'signedIn') {
        router.push(SHOWCASE_AUTOMATION_PATH)
      }
    }
  }
}
</script>
